(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4legz-landing"] && !Shopify.designMode) return;
  try {
    
  /* Legacy configurator retained for reference; replaced by the catalog-driven version below.
  (()=>{const root=document.querySelector('[data-fourlegz-section]');if(!root)return;const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format((Number(cents)||0)/100);const configs={};root.querySelectorAll('[data-product-config]').forEach(el=>{configs[el.dataset.key]={el,variant:el.dataset.variantId,once:Number(el.dataset.oncePrice),plans:[...el.querySelectorAll('[data-selling-plan]')].map(p=>({id:p.dataset.planId,name:p.dataset.planName,price:Number(p.dataset.planPrice)}))}});const singleKeys=['pumpkin','sweetpotato','pbmolasses','mint','ginger','carob'];const singlePlanSource=singleKeys.map(key=>configs[key]).find(cfg=>cfg?.plans.length);if(singlePlanSource)singleKeys.forEach(key=>{if(configs[key]&&!configs[key].plans.length&&configs[key].once===singlePlanSource.once)configs[key].plans=singlePlanSource.plans.map(plan=>({...plan}))});const images={pumpkin:'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-pumpkin.png?v=1789002670',sweetpotato:'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-sweet-potato.png?v=1789002658',pbmolasses:'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-pb-molasses.png?v=1789002745',mint:'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-chehalis-mint.png?v=1789002730',ginger:'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-ginger.png?v=1789002754',carob:'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-carob.png?v=1789002813'};const names={pumpkin:'Pumpkin Dog Treats',sweetpotato:'Sweet Potato Dog Treats',pbmolasses:'Peanut Butter & Molasses',mint:'Chehalis Mint Dog Treats',ginger:'Molasses Ginger Snap',carob:'Peanut Butter & Carob Chips',pack4:'4-Pack Variety Box',pack6:'6-Pack Flavor Sampler'};let state={size:'single',flavor:'pumpkin',plan:'sub',frequency:'monthly',quantity:1};const q=s=>root.querySelector(s),qa=s=>[...root.querySelectorAll(s)];const cadence=plan=>{const n=plan.name.toLowerCase();if(n.includes('3 month')||n.includes('quarter'))return'quarterly';if(n.includes('2 month')||n.includes('bi-month'))return'bimonthly';return'monthly'};const currentKey=()=>state.size==='single'?state.flavor:state.size;const current=()=>configs[currentKey()];function choosePlan(cfg){return cfg?.plans.find(p=>cadence(p)===state.frequency)||null}function render(){const key=currentKey(),cfg=current();qa('[data-size]').forEach(b=>b.classList.toggle('is-active',b.dataset.size===state.size));qa('[data-flavor]').forEach(b=>b.classList.toggle('is-active',b.dataset.flavor===state.flavor));q('[data-flavor-choices]').hidden=state.size!=='single';q('[data-product-heading]').textContent=names[key]||cfg?.el.dataset.productTitle||'4Legz Dog Treats';q('[data-single-image]').hidden=state.size!=='single';q('[data-pack4-image]').hidden=state.size!=='pack4';q('[data-pack6-image]').hidden=state.size!=='pack6';if(state.size==='single')q('[data-single-image]').src=images[state.flavor];const box=q('[data-box-contents]');box.hidden=state.size==='single';if(state.size==='pack4')box.innerHTML='<strong>Four set flavors, 1 lb each</strong><br>Sweet Potato · Peanut Butter & Molasses · Cranberry Apple · Blueberry Pancake<br><b>Free shipping included</b>';if(state.size==='pack6')box.innerHTML='<strong>Six smaller bags, six flavors</strong><br>Pumpkin · Sweet Potato · Peanut Butter & Molasses · Chehalis Mint · Molasses Ginger Snap · Peanut Butter & Carob<br><b>Free shipping included</b>';if(!cfg){q('[data-add-button]').disabled=true;q('[data-order-summary]').textContent='This product still needs to be selected in the theme editor.';return}q('[data-plan-card="sub"]').hidden=!cfg.plans.length;const available={};cfg.plans.forEach(p=>available[cadence(p)]=p);qa('[data-frequency]').forEach(b=>{b.disabled=!available[b.dataset.frequency];b.classList.toggle('is-active',state.frequency===b.dataset.frequency&&!!available[b.dataset.frequency])});if(!available[state.frequency]&&cfg.plans.length)state.frequency=cadence(cfg.plans[0]);const selectedPlan=choosePlan(cfg);if(!cfg.plans.length&&state.plan==='sub')state.plan='once';q('[data-plan-warning]').hidden=cfg.plans.length>0;qa('[data-plan-card]').forEach(c=>c.classList.toggle('is-active',c.dataset.planCard===state.plan));const price=state.plan==='sub'&&selectedPlan?selectedPlan.price:cfg.once;const discount=selectedPlan?Math.round((1-selectedPlan.price/cfg.once)*100):0;q('[data-subscribe-title]').textContent=discount?`Subscribe & Save ${discount}%`:'Subscribe';q('[data-subscribe-price]').textContent=selectedPlan?money(selectedPlan.price):'Unavailable';q('[data-once-price]').textContent=money(cfg.once);q('[data-savings]').textContent=selectedPlan?`Save ${money(cfg.once-selectedPlan.price)} on every order.`:'';q('[data-variant-input]').value=cfg.variant;const sp=q('[data-selling-plan-input]');sp.disabled=state.plan!=='sub'||!selectedPlan;sp.value=selectedPlan?.id||'';q('[data-quantity-input]').value=state.quantity;q('[data-add-button]').disabled=false;q('[data-order-summary]').textContent=`${state.quantity} × ${names[key]} · ${money(price)}${state.plan==='sub'?' per delivery':''}`};qa('[data-size]').forEach(b=>b.addEventListener('click',()=>{state.size=b.dataset.size;render()}));qa('[data-flavor]').forEach(b=>b.addEventListener('click',()=>{state.flavor=b.dataset.flavor;render()}));qa('[data-choose-key]').forEach(b=>b.addEventListener('click',()=>{state.size='single';state.flavor=b.dataset.chooseKey;render();q('[data-product-heading]').scrollIntoView({behavior:'smooth',block:'start'})}));qa('[data-select-plan]').forEach(b=>b.addEventListener('click',()=>{state.plan=b.dataset.selectPlan;render()}));qa('[data-frequency]').forEach(b=>b.addEventListener('click',()=>{if(!b.disabled){state.frequency=b.dataset.frequency;state.plan='sub';render()}}));q('[data-quantity-minus]').addEventListener('click',()=>{state.quantity=Math.max(1,state.quantity-1);render()});q('[data-quantity-plus]').addEventListener('click',()=>{state.quantity=Math.min(9,state.quantity+1);render()});q('[data-quantity-input]').addEventListener('change',e=>{state.quantity=Math.max(1,Math.min(9,Number(e.target.value)||1));render()});render()})();
  (()=>{const root=document.querySelector('[data-fourlegz-section]');if(!root)return;const names={pumpkin:'Pumpkin Dog Treats',sweetpotato:'Sweet Potato Dog Treats',pbmolasses:'Peanut Butter & Molasses',mint:'Chehalis Mint Dog Treats',ginger:'Molasses Ginger Snap',carob:'Peanut Butter & Carob Chips',pack4:'4-Pack Variety Box',pack6:'6-Pack Flavor Sampler'};const ingredients={pumpkin:'Organic rye flour, organic oat flour, organic pumpkin puree, cold-pressed canola oil, ground cinnamon, ground cloves, and water.',sweetpotato:'Organic rye flour, organic oat flour, organic sweet potato puree, cold-pressed canola oil, ground ginger, and water.',pbmolasses:'Organic rye flour, organic oat flour, organic unsalted peanut butter, unsulphured blackstrap molasses, canola oil, rolled oats, and ground cinnamon.',mint:'Organic rye flour, organic oat flour, rolled oats, canola oil, mint oil, cut and sifted rosemary, and ground ginger.',ginger:'Organic rye flour, oat flour, unsulphured blackstrap molasses, canola oil, ground ginger, ground cinnamon, and ground cloves.',carob:'Organic rye flour, oat flour, organic peanut butter, canola oil, carob chips, and ground cinnamon.',pack4:'<p><strong>Sweet Potato:</strong> Organic rye flour, organic oat flour, organic sweet potato puree, cold-pressed canola oil, ground ginger, and water.</p><p><strong>Peanut Butter & Molasses:</strong> Organic rye flour, organic oat flour, organic unsalted peanut butter, unsulphured blackstrap molasses, canola oil, rolled oats, and ground cinnamon.</p><p><strong>Cranberry Apple:</strong> Oat flour, rye flour, cranberry puree, apple cider vinegar, canola oil, ground cinnamon, and water.</p><p><strong>Blueberry Pancake:</strong> Organic rye flour, oat flour, unsulphured blackstrap molasses, blueberry puree, canola oil, and ground ginger.</p>',pack6:'<p><strong>Pumpkin:</strong> Organic rye flour, organic oat flour, organic pumpkin puree, cold-pressed canola oil, ground cinnamon, ground cloves, and water.</p><p><strong>Sweet Potato:</strong> Organic rye flour, organic oat flour, organic sweet potato puree, cold-pressed canola oil, ground ginger, and water.</p><p><strong>Peanut Butter & Molasses:</strong> Organic rye flour, organic oat flour, organic unsalted peanut butter, unsulphured blackstrap molasses, canola oil, rolled oats, and ground cinnamon.</p><p><strong>Chehalis Mint:</strong> Organic rye flour, organic oat flour, rolled oats, canola oil, mint oil, cut and sifted rosemary, and ground ginger.</p><p><strong>Molasses Ginger Snap:</strong> Organic rye flour, oat flour, unsulphured blackstrap molasses, canola oil, ground ginger, ground cinnamon, and ground cloves.</p><p><strong>Peanut Butter & Carob:</strong> Organic rye flour, oat flour, organic peanut butter, canola oil, carob chips, and ground cinnamon.</p>'};const update=()=>{const size=root.querySelector('[data-size].is-active')?.dataset.size||'single';const flavor=root.querySelector('[data-flavor].is-active')?.dataset.flavor||'pumpkin';const key=size==='single'?flavor:size;root.querySelector('[data-ingredient-title]').textContent=names[key];const body=root.querySelector('[data-ingredients]');if(key==='pack4'||key==='pack6')body.innerHTML=ingredients[key];else body.textContent=ingredients[key]};root.addEventListener('click',event=>{if(event.target.closest('[data-size],[data-flavor],[data-choose-key]'))requestAnimationFrame(update)});update()})();
  */
  (() => {
    const root = document.querySelector('[data-fourlegz-section]');
    if (!root) return;

    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
    const names = {
      pumpkin: 'Pumpkin Dog Treats',
      sweetpotato: 'Sweet Potato Dog Treats',
      pbmolasses: 'Peanut Butter & Molasses',
      mint: 'Chehalis Mint Dog Treats',
      ginger: 'Molasses Ginger Snap',
      carob: 'Peanut Butter & Carob Chips',
      cranberry: 'Cranberry Apple Dog Treats',
      blueberry: 'Blueberry Pancake Dog Treats',
      pack4: '4-Pack Variety Box',
      pack6: '6-Pack Doggy Box'
    };
    const descriptions = {
      pack4: 'Four large 1 lb bags in four customer-favorite flavors. Free shipping included.',
      pack6: 'Six smaller bags featuring six classic 4Legz flavors. Free shipping included.'
    };
    const displayImages = {
      pumpkin: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-pumpkin.png?v=1789002670',
      sweetpotato: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-sweet-potato.png?v=1789002658',
      pbmolasses: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-pb-molasses.png?v=1789002745',
      mint: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-chehalis-mint.png?v=1789002730',
      ginger: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-ginger.png?v=1789002754',
      carob: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/landing-shot-carob.png?v=1789002813',
      cranberry: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/188cfa87-a0e0-4496-838c-9c57b6ea5f0e.png?v=1771277851',
      blueberry: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/products/BP1lbbagphoto.png?v=1787153670',
      pack4: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/files/Untitleddesign_18.png?v=1771277859',
      pack6: 'https://cdn.shopify.com/s/files/1/0612/8635/1029/products/giftbox.png?v=1787090714'
    };
    const ingredients = {
      pumpkin: 'Organic rye flour, organic oat flour, organic pumpkin puree, cold-pressed canola oil, ground cinnamon, ground cloves, and water.',
      sweetpotato: 'Organic rye flour, organic oat flour, organic sweet potato puree, cold-pressed canola oil, ground ginger, and water.',
      pbmolasses: 'Organic rye flour, organic oat flour, organic unsalted peanut butter, unsulphured blackstrap molasses, canola oil, rolled oats, and ground cinnamon.',
      mint: 'Organic rye flour, organic oat flour, rolled oats, canola oil, mint oil, cut and sifted rosemary, and ground ginger.',
      ginger: 'Organic rye flour, oat flour, unsulphured blackstrap molasses, canola oil, ground ginger, ground cinnamon, and ground cloves.',
      carob: 'Organic rye flour, oat flour, organic peanut butter, canola oil, carob chips, and ground cinnamon.',
      cranberry: 'Oat flour, rye flour, cranberry puree, apple cider vinegar, canola oil, ground cinnamon, and water.',
      blueberry: 'Organic rye flour, oat flour, unsulphured blackstrap molasses, blueberry puree, canola oil, and ground ginger.',
      pack4: '<p><strong>Sweet Potato:</strong> Organic rye flour, organic oat flour, organic sweet potato puree, cold-pressed canola oil, ground ginger, and water.</p><p><strong>Peanut Butter & Molasses:</strong> Organic rye flour, organic oat flour, organic unsalted peanut butter, unsulphured blackstrap molasses, canola oil, rolled oats, and ground cinnamon.</p><p><strong>Cranberry Apple:</strong> Oat flour, rye flour, cranberry puree, apple cider vinegar, canola oil, ground cinnamon, and water.</p><p><strong>Blueberry Pancake:</strong> Organic rye flour, oat flour, unsulphured blackstrap molasses, blueberry puree, canola oil, and ground ginger.</p>',
      pack6: '<p><strong>Pumpkin:</strong> Organic rye flour, organic oat flour, organic pumpkin puree, cold-pressed canola oil, ground cinnamon, ground cloves, and water.</p><p><strong>Sweet Potato:</strong> Organic rye flour, organic oat flour, organic sweet potato puree, cold-pressed canola oil, ground ginger, and water.</p><p><strong>Peanut Butter & Molasses:</strong> Organic rye flour, organic oat flour, organic unsalted peanut butter, unsulphured blackstrap molasses, canola oil, rolled oats, and ground cinnamon.</p><p><strong>Chehalis Mint:</strong> Organic rye flour, organic oat flour, rolled oats, canola oil, mint oil, cut and sifted rosemary, and ground ginger.</p><p><strong>Molasses Ginger Snap:</strong> Organic rye flour, oat flour, unsulphured blackstrap molasses, canola oil, ground ginger, ground cinnamon, and ground cloves.</p><p><strong>Peanut Butter & Carob:</strong> Organic rye flour, oat flour, organic peanut butter, canola oil, carob chips, and ground cinnamon.</p>'
    };
    const smallWeights = { pbmolasses: '8 oz bag' };
    const configs = {};
    root.querySelectorAll('[data-product-config]').forEach(el => {
      const key = el.dataset.key;
      if (!configs[key]) configs[key] = [];
      configs[key].push({
        el,
        variant: el.dataset.variantId,
        variantTitle: el.dataset.variantTitle || '',
        image: el.dataset.imageUrl || '',
        once: Number(el.dataset.oncePrice),
        available: el.dataset.available !== 'false',
        plans: [...el.querySelectorAll('[data-selling-plan]')].map(plan => ({
          id: plan.dataset.planId,
          name: plan.dataset.planName,
          price: Number(plan.dataset.planPrice)
        }))
      });
    });

    const q = selector => root.querySelector(selector);
    const qa = selector => [...root.querySelectorAll(selector)];
    const isPack = key => key === 'pack4' || key === 'pack6';
    const sizeLabel = (key, title) => {
      const normalized = title.replace(/\s*\/\s*Retail.*$/i, '').replace(/^Retail\s*/i, '').trim();
      if (/Small Bulk 1\s*lb/i.test(normalized) || /^1\s*lb/i.test(normalized)) return '1 lb bag';
      if (/Party 4\s*lbs?/i.test(normalized)) return '4 lb bag';
      if (/Bulk 10\s*lbs?/i.test(normalized) || /^10\s*lbs?/i.test(normalized)) return '10 lb box';
      if (/^Small$/i.test(normalized)) return smallWeights[key] || '7 oz bag';
      return normalized || 'One box';
    };
    const sizeRank = (key, title) => {
      const label = sizeLabel(key, title);
      if (label.includes('oz')) return 0;
      if (label.startsWith('1 lb')) return 1;
      if (label.startsWith('4 lb')) return 2;
      if (label.startsWith('10 lb')) return 3;
      return 4;
    };
    Object.keys(configs).forEach(key => configs[key].sort((a, b) => sizeRank(key, a.variantTitle) - sizeRank(key, b.variantTitle)));

    let state = { key: 'pumpkin', variant: null, plan: 'sub', frequency: 'monthly', quantity: 1 };
    let lastSingleKey = 'pumpkin';
    const cadence = plan => {
      const name = plan.name.toLowerCase();
      if (name.includes('3 month') || name.includes('quarter')) return 'quarterly';
      if (name.includes('2 month') || name.includes('bi-month')) return 'bimonthly';
      return 'monthly';
    };
    const variants = () => configs[state.key] || [];
    const current = () => variants().find(config => config.variant === state.variant) || variants().find(config => config.available) || variants()[0];
    const choosePlan = config => config?.plans.find(plan => cadence(plan) === state.frequency) || config?.plans[0] || null;

    function setProduct(key) {
      if (!configs[key]?.length) return;
      state.key = key;
      if (!isPack(key)) lastSingleKey = key;
      state.variant = (configs[key].find(config => config.available) || configs[key][0]).variant;
      const config = current();
      state.plan = config.plans.length ? 'sub' : 'once';
      if (config.plans.length) state.frequency = cadence(config.plans[0]);
      render();
    }

    function render() {
      const config = current();
      if (!config) {
        q('[data-add-button]').disabled = true;
        q('[data-order-summary]').textContent = 'This product still needs to be selected in the theme editor.';
        return;
      }

      qa('[data-flavor]').forEach(button => button.classList.toggle('is-active', !isPack(state.key) && button.dataset.flavor === state.key));
      qa('[data-purchase-key]').forEach(button => {
        const selected = button.dataset.purchaseKey === 'single' ? !isPack(state.key) : button.dataset.purchaseKey === state.key;
        button.classList.toggle('is-active', selected);
      });
      q('[data-product-heading]').textContent = names[state.key] || config.el.dataset.productTitle || '4Legz Dog Treats';
      q('[data-product-description]').textContent = descriptions[state.key] || 'Choose an available bag size, then buy once or select an available subscription schedule.';
      q('[data-product-image]').src = displayImages[state.key] || config.image;
      q('[data-product-image]').alt = names[state.key] || 'Selected 4Legz dog treats';

      q('[data-flavor-choices]').hidden = isPack(state.key);
      const sizeChoices = q('[data-size-choices]');
      sizeChoices.hidden = isPack(state.key);
      const sizeButtons = q('[data-size-buttons]');
      sizeButtons.innerHTML = variants().map(variant => {
        const active = variant.variant === config.variant ? ' class="is-active"' : '';
        const disabled = variant.available ? '' : ' disabled';
        const status = variant.available ? 'Available now' : 'Sold out';
        return `<button type="button" data-variant="${variant.variant}"${active}${disabled}><strong>${sizeLabel(state.key, variant.variantTitle)}</strong><span>${status}</span><b>${money(variant.once)}</b></button>`;
      }).join('');

      const box = q('[data-box-contents]');
      box.hidden = !isPack(state.key);
      if (state.key === 'pack4') box.innerHTML = '<strong>Four 1 lb bags</strong><br>Sweet Potato · Peanut Butter & Molasses · Cranberry Apple · Blueberry Pancake<br><b>Free shipping included</b>';
      if (state.key === 'pack6') box.innerHTML = '<strong>Six smaller bags, six flavors</strong><br>Pumpkin · Sweet Potato · Peanut Butter & Molasses · Chehalis Mint · Molasses Ginger Snap · Peanut Butter & Carob<br><b>Free shipping included</b>';

      q('[data-ingredient-title]').textContent = names[state.key];
      const ingredientBody = q('[data-ingredients]');
      if (isPack(state.key)) ingredientBody.innerHTML = ingredients[state.key];
      else ingredientBody.textContent = ingredients[state.key] || '';

      const available = {};
      config.plans.forEach(plan => { available[cadence(plan)] = plan; });
      if (!available[state.frequency] && config.plans.length) state.frequency = cadence(config.plans[0]);
      const selectedPlan = choosePlan(config);
      if (!config.plans.length) state.plan = 'once';
      q('[data-plan-card="sub"]').hidden = !config.plans.length;
      qa('[data-frequency]').forEach(button => {
        button.disabled = !available[button.dataset.frequency];
        button.classList.toggle('is-active', state.frequency === button.dataset.frequency && Boolean(available[button.dataset.frequency]));
      });
      qa('[data-plan-card]').forEach(card => card.classList.toggle('is-active', card.dataset.planCard === state.plan));

      const price = state.plan === 'sub' && selectedPlan ? selectedPlan.price : config.once;
      const discount = selectedPlan ? Math.round((1 - selectedPlan.price / config.once) * 100) : 0;
      q('[data-subscribe-title]').textContent = discount ? `Subscribe & Save ${discount}%` : 'Subscribe';
      q('[data-subscribe-price]').textContent = selectedPlan ? money(selectedPlan.price) : '';
      q('[data-once-price]').textContent = money(config.once);
      q('[data-savings]').textContent = selectedPlan ? `Save ${money(config.once - selectedPlan.price)} on every order.` : '';
      q('[data-variant-input]').value = config.variant;
      const sellingPlanInput = q('[data-selling-plan-input]');
      sellingPlanInput.disabled = state.plan !== 'sub' || !selectedPlan;
      sellingPlanInput.value = selectedPlan?.id || '';
      q('[data-quantity-input]').value = state.quantity;
      q('[data-add-button]').disabled = !config.available;
      const sizeText = isPack(state.key) ? '' : ` · ${sizeLabel(state.key, config.variantTitle)}`;
      q('[data-order-summary]').textContent = `${state.quantity} × ${names[state.key]}${sizeText} · ${money(price)}${state.plan === 'sub' ? ' per delivery' : ''}`;
    }

    root.addEventListener('click', event => {
      const flavor = event.target.closest('[data-flavor]');
      const purchase = event.target.closest('[data-purchase-key]');
      const productCard = event.target.closest('[data-choose-key]');
      const variant = event.target.closest('[data-variant]');
      const plan = event.target.closest('[data-select-plan]');
      const frequency = event.target.closest('[data-frequency]');
      if (flavor) setProduct(flavor.dataset.flavor);
      if (purchase) setProduct(purchase.dataset.purchaseKey === 'single' ? lastSingleKey : purchase.dataset.purchaseKey);
      if (productCard) {
        setProduct(productCard.dataset.chooseKey);
        q('[data-product-heading]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (variant) {
        state.variant = variant.dataset.variant;
        const config = current();
        state.plan = config.plans.length ? 'sub' : 'once';
        if (config.plans.length) state.frequency = cadence(config.plans[0]);
        render();
      }
      if (plan) { state.plan = plan.dataset.selectPlan; render(); }
      if (frequency && !frequency.disabled) { state.frequency = frequency.dataset.frequency; state.plan = 'sub'; render(); }
    });
    q('[data-quantity-minus]').addEventListener('click', () => { state.quantity = Math.max(1, state.quantity - 1); render(); });
    q('[data-quantity-plus]').addEventListener('click', () => { state.quantity = Math.min(9, state.quantity + 1); render(); });
    q('[data-quantity-input]').addEventListener('change', event => { state.quantity = Math.max(1, Math.min(9, Number(event.target.value) || 1)); render(); });
    setProduct('pumpkin');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (() => {
    document.addEventListener('change', async (event) => {
      const select = event.target.closest('.fourlegz-purchase-panel__select');
      if (!select) return;

      const cart = select.closest('cart-items.fourlegz-cart');
      const panel = select.closest('.fourlegz-purchase-panel');
      const status = panel.querySelector('.fourlegz-purchase-panel__status');
      const checkoutButtons = document.querySelectorAll('[name="checkout"]');
      const previousValue = select.dataset.currentValue;

      panel.classList.add('is-updating');
      select.disabled = true;
      checkoutButtons.forEach((button) => { button.disabled = true; });
      status.hidden = false;
      status.textContent = cart.dataset.updatingPurchaseOption;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            line: Number(select.dataset.line),
            quantity: Number(select.dataset.quantity),
            selling_plan: select.value || null
          })
        });

        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (error) {
        select.value = previousValue;
        select.disabled = false;
        checkoutButtons.forEach((button) => { button.disabled = false; });
        panel.classList.remove('is-updating');
        status.textContent = cart.dataset.purchaseOptionError;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
